import { IMessageRecipient } from 'Modules/Communication/shared/models/Inbox'
import { mobilenumber } from 'shared/constants/regex'
import { SmsSettings } from 'shared/models/Message'
import {
  charsInMultipleSms,
  charsInSingleSms,
} from '../constants/sms-constants'

export const isSendAllowed = (smsSettings: SmsSettings) =>
  smsSettings &&
  (!smsSettings.maxLimit ||
    smsSettings.numberOfSmsNotInvoiced < smsSettings.maxLimit) &&
  smsSettings.isSmsAvailable

export const getTotalSmsCount = (contentChars: number) =>
  contentChars <= charsInSingleSms
    ? 1
    : Math.ceil(contentChars / charsInMultipleSms)

export const getMaxCountForCurrentSms = (contentChars: number) => {
  const smsCount = getTotalSmsCount(contentChars)
  return smsCount === 1 ? charsInSingleSms : smsCount * charsInMultipleSms
}

export const isValidMobileNumber = (mobile: string): boolean =>
  mobilenumber.test(mobile)

// remove whitespace and all valid country codes (norway)
const getStrippedMobileNumber = (mobile?: string) =>
  (mobile || '')
    .replace(/ /g, '')
    .replace(/^(\+47)/, '')
    .replace(/^(0047)/, '')

export const getUniqueValidRecipientsCount = (
  recipients: Partial<IMessageRecipient>[]
): number => {
  const uniquePhoneNrs = recipients
    .map((rec) => rec.phonenumber)
    .filter((value, index, self) => {
      const selfCompare = self.map((mobile) => getStrippedMobileNumber(mobile))

      return selfCompare.indexOf(getStrippedMobileNumber(value)) === index
    })

  return uniquePhoneNrs.filter(
    (mobile) => mobile?.trim() && isValidMobileNumber(mobile)
  ).length
}
